import { FC } from 'react';
import { addComma } from '@doda/common/src/utils/convNumberUtil';
import styles from './index.module.scss';

/**
 * 表示求人数
 * @interface Props
 */
interface Props {
  /** 全体の求人数 */
  totalCount: number;
  /** 現在の表示結果数 */
  resultCount: number;
  /** 現在のオフセット */
  offset: number;
}

/**
 * 該当求人数を表示するコンポーネント
 * @param {Props} props - コンポーネントに渡されるプロパティ
 * @returns {JSX.Element} 該当求人数を表示する要素
 */
export const DisplayJobCount: FC<Props> = ({
  totalCount,
  resultCount,
  offset,
}) => {
  const perPageNum = `${addComma(offset + 1)}～${addComma(resultCount + offset)}`;

  return (
    <p className={styles.displayJobCount}>
      該当求人数
      <span className={styles.displayJobCount__totalNum}>
        {addComma(totalCount)}
      </span>
      件中
      <span className={styles.displayJobCount__perPageNum}>
        {totalCount !== 0 ? perPageNum : '0'}件
      </span>
      を表示
    </p>
  );
};
